import { apiFetch } from "../../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.error || data.message || fallback;
};
export async function getTravelPlanDetail(params) {
    const { baseUrl, travelPlanId, travelPlanSlug, detailUrl, token, userId } = params;
    const identifier = travelPlanSlug !== null && travelPlanSlug !== void 0 ? travelPlanSlug : travelPlanId;
    let path = "";
    if (typeof detailUrl === "string" && detailUrl.trim() !== "") {
        const normalizedDetailUrl = detailUrl.trim();
        if (/^https?:\/\//i.test(normalizedDetailUrl)) {
            try {
                const parsedUrl = new URL(normalizedDetailUrl);
                path = `${parsedUrl.pathname}${parsedUrl.search}`;
            }
            catch {
                path = normalizedDetailUrl;
            }
        }
        else {
            path = normalizedDetailUrl;
        }
    }
    else if (identifier !== undefined && identifier !== null && String(identifier).trim() !== "") {
        path = `/travel/api/get_travel_plan_detail/${identifier}/`;
    }
    else {
        throw new Error("Не указан идентификатор путешествия");
    }
    const queryJoiner = path.includes("?") ? "&" : "?";
    const query = userId ? `${queryJoiner}user_id=${encodeURIComponent(String(userId))}` : "";
    const data = await apiFetch(`${path}${query}`, {
        baseUrl,
        token,
        method: "GET"
    });
    if (!data.success) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить детали путешествия"));
    }
    return data;
}
export async function startTravelPlan(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_start/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({})
    });
}
export async function updateTravelPlan(params) {
    const { baseUrl, travelPlanId, formData, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_update/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
}
export async function toggleTravelPlanUserMap(params) {
    const { baseUrl, travelPlanId, enabled, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_user_map_toggle/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({ show_on_user_map: enabled })
    });
}
export async function setTravelPlanProfileVisibility(params) {
    const { baseUrl, travelPlanId, visibilityScope, isProfileVisible, tabs, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_profile_visibility/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({
            ...(visibilityScope ? { visibility_scope: visibilityScope } : {}),
            ...(typeof isProfileVisible === "boolean" ? { is_profile_visible: isProfileVisible } : {}),
            ...(tabs ? { tabs } : {})
        })
    });
}
export async function getTravelPlanProfileVisibility(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/travel_plan_profile_visibility/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
const jsonHeaders = (csrfToken) => ({
    "Content-Type": "application/json",
    ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
});
export async function inviteUserToTravel(params) {
    const { baseUrl, token, csrfToken, toUserId, travelPlanId } = params;
    return apiFetch("/travel/api/invite_user_to_travel/", {
        baseUrl,
        token,
        method: "POST",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({ to_user_id: toUserId, travel_plan_id: travelPlanId })
    });
}
export async function cancelTravelInvite(params) {
    const { baseUrl, token, csrfToken, toUserId, travelPlanId, travelRequestId } = params;
    return apiFetch("/travel/api/cancel_travel_invite/", {
        baseUrl,
        token,
        method: "POST",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({
            to_user_id: toUserId,
            travel_plan_id: travelPlanId,
            travel_request_id: travelRequestId
        })
    });
}
export async function inviteAllFriendsToTravel(params) {
    const { baseUrl, token, csrfToken, travelPlanId } = params;
    return apiFetch(`/travel/api/invite_all_friends_to_travel/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: jsonHeaders(csrfToken)
    });
}
export async function setParticipantCanEdit(params) {
    const { baseUrl, token, csrfToken, travelPlanId, profileId, canEdit } = params;
    return apiFetch(`/travel/api/set_participant_can_edit/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({ profile_id: profileId, can_edit: canEdit })
    });
}
export async function removeTravelParticipant(params) {
    const { baseUrl, token, csrfToken, travelPlanId, deleteUserId, leaveSelf = false } = params;
    return apiFetch(`/travel/api/remove_travel_participant/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: jsonHeaders(csrfToken),
        body: JSON.stringify({
            ...(deleteUserId !== undefined ? { delete_user_id: deleteUserId } : {}),
            ...(leaveSelf ? { leave_self: true } : {})
        })
    });
}
